<template>
  <form-accordion :title="configTitle" :isTitleUpperCase="false">
    <b-row>
      <b-col cols="6" class="form-group" v-if="isEditable">
        <label>
          {{ $t('common.routing.config_type') }}
        </label>
        <select class="form-control" v-model="configType" @change="/*emptyFields*/">
          <option v-for="config in configTypeList" :key="config.id" :value="config.value">
            {{ config.name }}
          </option>
        </select>
      </b-col>
      <b-col cols="6" class="form-group" v-else>
        <form-read-group-label-input
        :inputLabel="$t('common.routing.config_type')"
        :inputValue="configType"
        ></form-read-group-label-input>
      </b-col>
    </b-row>
    <mq-series-configuration-form v-if="configType === 'MQSERIES'" v-model="configMQSeries"></mq-series-configuration-form>
    <web-service-configuration-form v-if="configType === 'WEBSERVICE'" v-model="configWebService"></web-service-configuration-form>
  </form-accordion>
</template>
<script>
import backButton from "@/components/common/backButton.vue"
import FormAccordion from '@/components/common/FormAccordion.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import MQSeriesConfigurationForm from '@/pages/routing/MQSeriesConfigurationForm.vue'
import WebServiceConfigurationForm from '@/pages/routing/WebServiceConfigurationForm.vue'


export default {
name: 'ConfigSortieForm.vue',
components: {
  'back-button': backButton,
  'form-accordion': FormAccordion,
  'form-read-group-label-input': formReadGroupLabelInput,
  'form-write-group-label-input': formWriteGroupLabelInput,
  'page-outline': PageOutline,
  'mq-series-configuration-form':MQSeriesConfigurationForm,
  'web-service-configuration-form':WebServiceConfigurationForm

},
props: {
  mode: {
  type: String,
    default: 'add'
  },
  id: {
    type: String,
    default: '-1'
  },
  isEditable: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: ''
  },
  value: {
    type: Object,
    default: () => {
      return {}
    }
  }
},
computed: {
  inputValue: {
    get () {
      return this.value
    },
    set (val) {
      this.$emit('input', val)
    }
  },
  configType:{
    get () {
      return this.inputValue.configType
    },
    set (val) {
      this.inputValue = {
        configType: val,
        configMQSeries: this.inputValue.configMQSeries,
        configWebService: this.inputValue.configWebService
      }
    }
  },
  configMQSeries:{
    get () {
      return this.inputValue.configMQSeries
    },
    set (val) {
      this.inputValue = {
        configType: this.inputValue.configType,
        configMQSeries: val,
        configWebService: this.inputValue.configWebService
      }
    }
  },
  configWebService:{
    get () {
      return this.inputValue.configWebService
    },
    set (val) {
      this.inputValue = {
        configType: this.inputValue.configType,
        configMQSeries: this.inputValue.configMQSeries,
        configWebService: val
      }
    }
  },
},
data () {
  return {
    certificateConfigList: [],
    config: {},
    configAdded: false,
    configTitle: '',
    messageConfigList: [],
    mqseriesConfigList: [],
    selectedMessageType: 0,
    selectedConfigType: 0,
    selectedMessageFormat: 0,
    selectedMQSeries: [],
    selectedWebService: [],
    webServiceConfigList: []
  }
},
created () {
  this.configTitle = this.title ? this.title : this.$i18n.t('common.global.config_in')
  this.configTypeList = [
    {
      id: 0,
      name: 'Selectionner un type de configuration...'
    },
    {
      id: 1,
      name: 'MQSeries',
      value: 'MQSERIES'
    },
    {
      id: 2,
      name: 'Web Service',
      value: 'WEBSERVICE'
    },
  ]
  this.getMessageRouting()
  this.getConfigMQSeries()
  this.getConfigWebService()
},
methods: {
  addConfig(){
    this.configAdded = !this.configAdded
  },
  emptyFields() {
    this.config = {}
    this.selectedMQSeries = []
    this.selectedWebService = []
  },
  fillConfigFieldsMQSeries() {
    this.config = {
      channelName: this.selectedMQSeries.ChannelName,
      connectionMode: this.selectedMQSeries.ConnectionMode,
      connectionType: this.selectedMQSeries.ConnectionType,
      host: this.selectedMQSeries.Host,
      // idMQSeries: this.selectedMQSeries.IdMQSeries,
      name: this.selectedMQSeries.Name,
      port: this.selectedMQSeries.Port,
      queueManager: this.selectedMQSeries.QueueManager,
      queueName: this.selectedMQSeries.QueueName,
      sslActive: this.selectedMQSeries.SSL
    }
  },
  fillConfigFieldsWebService() {
    this.config = {
      host: this.selectedWebService.Host,
      // idMQSeries: this.selectedWebService.IdWebService,
      name: this.selectedWebService.Name,
      port: this.selectedWebService.Port,
      sslActive: this.selectedWebService.SSLMode,
      uri: this.selectedWebService.URI,
    }
  },
  getConfigMQSeries () {
    this.$engine.routing.config.mqseries.fetch(
      {}
    ).then(resp => {
      let mqseriesList = {}

      mqseriesList = resp.data.MQSeries

      this.updatemqseries(mqseriesList)
    })
  },
  getConfigWebService () {
    this.$engine.routing.config.webService.fetch(
      {}
    ).then(resp => {
      let webServiceList = {}

      webServiceList = resp.data.WebService

      this.updateWebServices(webServiceList)
    })
  },
  getMessageRouting () {
    this.$engine.routing.message.fetch(
      {}
    ).then(resp => {
      let messageRouting = {}
      messageRouting = resp.data.MessageRouting
      this.updateMessages(messageRouting)
    })
  },
  updateMessages(messageRouting){
    this.messageConfigList = messageRouting
  },
  updatemqseries (mqseriesList) {
    this.mqseriesConfigList = mqseriesList
  },
  updateWebServices (webServiceList) {
    this.webServiceConfigList = webServiceList
  }
}
}
</script>
